import React from "react";
import { Link } from "gatsby";
import Layout from "../components/layout";
import SEO from "../components/seo";
import Container from "../components/container";
import styled from "@emotion/styled"
import faker from "faker";

const Styles = styled.div`
  padding: 30px 0px;

  .my-jobs {
    display: grid;
    grid-gap: 24px;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr))
  }
`

class Page extends React.Component {
  constructor () {
    super();
    this.state = {}
  }

  render () {
    let courses = [
      {
        title: faker.name.title(),
        author: faker.name.findName(),
      },

      {
        title: faker.name.title(),
        author: faker.name.findName(),
      },

      {
        title: faker.name.title(),
        author: faker.name.findName(),
      },

      {
        title: faker.name.title(),
        author: faker.name.findName(),
      },

      {
        title: faker.name.title(),
        author: faker.name.findName(),
      },
    ]
    return (
      <Layout path="jobs">
        <SEO title="Jobs" />
          <Styles>
        <Container>
              <div className="title">
                Jobs
              </div>

              <div className="my-jobs">
                {
                  courses.map( (el) => {
                    return (
                      <div>
                        <div className="card">
                          <div className="card-image">
                          <img src="https://picsum.photos/600/380"></img>
                          </div>
                          <div className="card-content">
                            <b style={{marginRight: 4}}>
                            {
                              el.title
                            }
                            </b>
                            <span style={{marginRight: 4}}>
                            by 
                            </span>

                            <span>
                              {
                                el.author
                              }
                            </span>
                            
                          </div>
                          
                          
                        
                        </div>

                      </div>
                    )
                  })
                }

              </div>
        </Container>

          </Styles>
      </Layout>
    )
  }
}

export default Page
